module.exports = __webpack_public_path__ + "img/slika1.e00d695e.jpg";